import React, { useEffect } from "react";
import { useState } from "react";
import {
  Button,
  Card,
  Divider,
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import { getFarmer } from "../../../redux/reducer/farmer/farmerReducer";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  getPurchaseOrderById,
  purchaseOrderActions,
  updatePurchaseOrder,
} from "../../../redux/reducer/purchaseOrder/purchaseOrderReducer";
import { getVegetablePrice } from "../../../redux/reducer/vegetablePrice/vegetablePriceReducer";
import { postDataWithParams } from "../../../service/Service";
import moment from "moment";
import NumberFormatting from "../../helper/NumberFormatting";
const useStyles = makeStyles(() => ({
  headerClass: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexDirection: "column",
    padding: "5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
  dividerStyle: {
    border: "1px solid #386E5B",
    width: "100%",
    margin: "5px 0px",
  },
  footerButton: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginBottom: "10px",
    width: "99%",
  },
  tableHeader: {
    background: "#ddd",
    textAlign: "center",
    borderBottom: "1px solid #D1CDCD",
    padding: "1em",
  },
  tableCell: {
    background: "#ddd",
    borderBottom: "1px solid #D1CDCD",
    padding: "5px 0px",
  },
  actionButtonEdit: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    textAlign: "center",
    borderRadius: "5px",
    margin: "auto",
    cursor: "pointer",
    "&:hover": {
      background: "#7dbda9",
    },
  },
}));

export default function AdminPurchaseOrderDetail() {
  // Navigate
  const { id } = useParams();
  const navigate = useNavigate();

  // Styling
  const styles = useStyles();

  // Redux Data
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.auth.dataToken);
  const farmer = useSelector((state) => state.farmer.data);
  const purchaseOrder = useSelector((state) => state.purchaseOrder.data);

  // Local State
  const [formData, setFormData] = useState({
    purchaseOrderCode: "",
    farmerId: "",
    totalPrices: "",
    status: "",
    isLate: "",
    arrivalDate: "",
    totalPayment: "",
    paymentDate: ""
  });
  const [vegetablePrice, setVegetablePrice] = useState([]);
  const [orderDetails, setOrderDetails] = useState([]);
  const [fetch, setFetch] = useState(true);

  useEffect(() => {
    if (fetch) {
      const x = purchaseOrder.docs.findIndex((item) => item._id === id);
      if (x > -1) {
        setFormData({
          purchaseOrderCode: purchaseOrder.docs[x].purchaseOrderCode
            ? purchaseOrder.docs[x].purchaseOrderCode
            : "",
          farmerId: purchaseOrder.docs[x].farmerId
            ? purchaseOrder.docs[x].farmerId._id
            : "",
          farmerName: purchaseOrder.docs[x].farmerId
            ? purchaseOrder.docs[x].farmerId.fullName
            : "",
          totalPrices: purchaseOrder.docs[x].totalPrices
            ? purchaseOrder.docs[x].totalPrices
            : "",
          status: purchaseOrder.docs[x].status
            ? purchaseOrder.docs[x].status
            : "",
          arrivalDate: purchaseOrder.docs[x].arrivalDetails
            ? moment(purchaseOrder.docs[x].arrivalDetails.arrivalDate).format(
                "YYYY-MM-DD"
              )
            : "",
          isLate: purchaseOrder.docs[x].arrivalDetails
            ? purchaseOrder.docs[x].arrivalDetails.isLate
            : "",
          totalPayment: purchaseOrder.docs[x].paymentDetails
            ? purchaseOrder.docs[x].paymentDetails.totalPayment
            : "",
          paymentDate: purchaseOrder.docs[x].paymentDetails
            ? moment(purchaseOrder.docs[x].paymentDetails.paymentDate).format(
                "YYYY-MM-DD"
              )
            : "",
        });
        let y = farmer.docs.findIndex((item) => item._id === formData.farmerId);
        if (y > -1) {
          let body = {
            priceTypeId: farmer.docs[y].priceTypeId._id,
          };
          let params = {
            paginate: false,
          };
          postDataWithParams(
            "/master/vegetable-price/search",
            token,
            body,
            params
          )
            .then((res) => {
              if (res.data.status === 200) {
                setVegetablePrice(res.data.data.docs);
              } else {
                toast.error(res.data.message);
              }
            })
            .catch((err) => {
              toast.error(err.response.message);
            });
        }
        let tempOrderDetails = [];
        purchaseOrder.docs[x].orderDetails.map((item) => {
          let data = {
            vegetablePriceId: item.vegetablePriceId._id,
            vegetablePriceName: item.vegetablePriceId.vegetableName,
            accept: item.accept,
            order: item.order,
            return: item.return,
            reject: item.reject,
            deviation: item.deviation,
            totalOrder: item.totalOrder,
            price: item.price,
          };
          tempOrderDetails.push(data);
        });
        setOrderDetails(tempOrderDetails);
      }
      setFetch(false);
    }
  }, [fetch]);

  // Basic Handle Change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Handling Order Details
  const handleOrderDetails = (index) => (e) => {
    const newItems = [...orderDetails];
    newItems[index][e.target.name] = e.target.value;
    newItems[index]["totalOrder"] =
      newItems[index]["order"] - newItems[index]["accept"];
    let x = vegetablePrice.findIndex(
      (item) => item._id === newItems[index]["vegetablePriceId"]
    );
    if (x > -1) {
      newItems[index]["price"] =
        newItems[index]["totalOrder"] * vegetablePrice[x].price;
    } else {
      newItems[index]["price"] = 0;
    }
    setFormData({
      ...formData,
      totalPrices: newItems.reduce(
        (acc, cur) => parseInt(acc) + parseInt(cur.price),
        0
      ),
    });
    setOrderDetails(newItems);
  };

  const handleAddOrderDetails = () => {
    setOrderDetails((prevItems) => [
      ...prevItems,
      {
        vegetablePriceId: "",
        order: "",
        accept: 0,
        reject: 0,
        return: 0,
        deviation: 0,
        totalOrder: "",
        price: "",
      },
    ]);
  };

  const handleDeleteOrderDetails = (value) => {
    let deletedData = [];
    for (let i = 0; i < orderDetails.length; i++) {
      if (i !== value) {
        deletedData.push(orderDetails[i]);
      }
    }
    setOrderDetails(deletedData);
  };

  const handleSubmitAll = (e) => {
    e.preventDefault();
    Swal.fire({
      title: `Mohon dicek kembali data yang akan di input`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Tambah",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        let data = {
          value: {
            purchaseOrderCode: formData.purchaseOrderCode,
            farmerId: formData.farmerId,
            orderDetails: orderDetails,
            totalPrices: formData.totalPrices,
            status: formData.status,
            createdBy: user.username,
            updatedBy: user.username,
          },
          id: id,
          token: token,
        };
        dispatch(updatePurchaseOrder(data)).then((res) => {
          if (res.payload.status === 200) {
            let dataGetById = {
              id: res.payload.data._id,
              token: token,
            };
            dispatch(getPurchaseOrderById(dataGetById)).then((result) => {
              dispatch(
                purchaseOrderActions.editPurchaseOrder(result.payload.data)
              );
              toast.success(res.payload.message);
              navigate("/petani/nota-petani");
            });
          }
        });
      } else {
        return;
      }
    });
  };

  const loadMore = (value) => (event) => {
    if (
      event.target.scrollHeight - event.target.scrollTop < 300 &&
      event.target.scrollTop < 100
    ) {
      if (farmer.totalDocs !== farmer.docs.length && value === 1) {
        const getData = {
          params: {
            limit: farmer.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getFarmer(getData));
      } else if (
        vegetablePrice.totalDocs !== vegetablePrice.docs.length &&
        value === 2
      ) {
        const getData = {
          params: {
            limit: vegetablePrice.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getVegetablePrice(getData));
      }
    }
  };

  const orderDetailsColumn = [
    "HARGA SAYURAN",
    "ORDER",
    "TERIMA",
    "REJECT",
    "RETURN",
    "DEVIASI",
    "TOTAL ORDER",
    "TOTAL HARGA",
    "AKSI",
  ];

  return (
    <Grid container>
      <ToastContainer />
      <Card className={styles.headerClass}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          DETAIL NOTA PETANI
        </Typography>
      </Card>
      <Card className={styles.headerClass}>
        <form
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginTop: "10px",
          }}
          onSubmit={handleSubmitAll}
        >
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              KODE NOTA PETANI
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{
                readOnly: true,
                maxLength: 20,
                style: { background: "white" },
              }}
              required
              helperText={
                formData.purchaseOrderCode.length > 0
                  ? /^[A-Za-z]{2}-\d{5}/.test(formData.purchaseOrderCode)
                    ? ""
                    : "*Format Kode Petani salah"
                  : ""
              }
              size="small"
              error={
                formData.purchaseOrderCode.length > 0
                  ? /^[A-Za-z]{2}-\d{5}/.test(formData.purchaseOrderCode)
                    ? false
                    : true
                  : false
              }
              name="purchaseOrderCode"
              onChange={handleChange}
              value={formData.purchaseOrderCode}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              marginBottom: "10px",
              flexDirection: "row",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              PETANI
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true }}
              required
              size="small"
              error={false}
              name="farmerId"
              onChange={handleChange}
              value={formData.farmerId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    onScroll: loadMore(1),
                  },
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.farmerName && formData.farmerId.length > 0 && (
                <MenuItem value={formData.farmerId} key={0}>
                  {formData.farmerName}
                </MenuItem>
              )}
              {farmer.docs.length > 0 ? (
                farmer.docs.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.fullName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>
          <Divider />
          <Typography
            marginTop={1}
            marginBottom={1}
            fontSize={14}
            color={"#2e473f"}
            variant="h6"
          >
            ORDER DETAIL
          </Typography>
          <table
            style={{
              width: "100%",
              marginBottom: "10px",
              borderCollapse: "collapse",
              borderRadius: "1em",
              overflow: "hidden",
            }}
          >
            <thead>
              {orderDetailsColumn.map((item, index) => {
                return (
                  <td className={styles.tableHeader} key={index}>
                    {item}
                  </td>
                );
              })}
            </thead>
            <tbody>
              {orderDetails.length > 0 &&
                orderDetails.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td className={styles.tableCell}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            select
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ readOnly: true }}
                            required
                            size="small"
                            error={false}
                            name="vegetablePriceId"
                            onChange={handleOrderDetails(index)}
                            value={item.vegetablePriceId}
                            fullWidth
                            variant="outlined"
                            SelectProps={{
                              MenuProps: {
                                PaperProps: {
                                  onScroll: loadMore(2),
                                },
                                style: {
                                  height: "300px",
                                },
                              },
                            }}
                            style={{
                              maxWidth: "400px",
                              background: "white",
                              marginRight: "10px",
                            }}
                          >
                            {item.vegetablePriceId && (
                              <MenuItem
                                value={item.vegetablePriceId}
                                key={index}
                                selected={true}
                              >
                                {item.vegetablePriceName}
                              </MenuItem>
                            )}
                            {vegetablePrice.length > 0 ? (
                              vegetablePrice.map((data, index) => (
                                <MenuItem value={data._id} key={index}>
                                  {data.vegetableName}
                                </MenuItem>
                              ))
                            ) : (
                              <MenuItem value="">Data kosong</MenuItem>
                            )}
                          </TextField>
                        </FormControl>
                      </td>

                      <td className={styles.tableCell}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ readOnly: true }}
                            required
                            size="small"
                            type="number"
                            error={false}
                            name="order"
                            id={index}
                            onChange={handleOrderDetails(index)}
                            value={item.order}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ readOnly: true }}
                            required
                            size="small"
                            type="number"
                            error={false}
                            name="accept"
                            id={index}
                            onChange={handleOrderDetails(index)}
                            value={item.accept}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ readOnly: true }}
                            required
                            size="small"
                            type="number"
                            error={false}
                            name="reject"
                            id={index}
                            onChange={handleOrderDetails(index)}
                            value={item.reject}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ readOnly: true }}
                            required
                            size="small"
                            type="number"
                            error={false}
                            name="return"
                            id={index}
                            onChange={handleOrderDetails(index)}
                            value={item.return}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ readOnly: true }}
                            required
                            size="small"
                            type="number"
                            error={false}
                            name="deviation"
                            id={index}
                            onChange={handleOrderDetails(index)}
                            value={item.deviation}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ readOnly: true }}
                            required
                            size="small"
                            type="number"
                            error={false}
                            name="totalOrder"
                            id={index}
                            onChange={handleOrderDetails(index)}
                            value={item.totalOrder}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell}>
                        <FormControl
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyItems: "flex-start",
                            flexDirection: "row",
                            margin: "auto",
                            width: "90%",
                          }}
                        >
                          <TextField
                            InputLabelProps={{ shrink: true }}
                            InputProps={{ readOnly: true }}
                            required
                            size="small"
                            error={false}
                            name="price"
                            id={index}
                            onChange={handleOrderDetails(index)}
                            value={item.price.toLocaleString("id", {
                              style: "currency",
                              currency: "IDR",
                            })}
                            variant="outlined"
                            fullWidth
                            style={{
                              background: "white",
                              marginRight: "10px",
                            }}
                          />
                        </FormControl>
                      </td>

                      <td className={styles.tableCell}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "auto",
                            width: "100px",
                          }}
                        >
                          <AddIcon
                            className={styles.actionButtonEdit}
                            onClick={() => handleAddOrderDetails()}
                          />
                          {orderDetails.length > 1 && index !== 0 ? (
                            <RemoveIcon
                              className={styles.actionButtonEdit}
                              onClick={() => handleDeleteOrderDetails(index)}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>

          <Divider />

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              TOTAL ORDERS
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{ readOnly: true, style: { background: "white" } }}
              required
              size="small"
              error={false}
              name="totalPrices"
              onChange={handleChange}
              value={formData.totalPrices.toLocaleString("id", {
                style: "currency",
                currency: "IDR",
              })}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "400px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <Divider />
          <Typography
            marginTop={1}
            marginBottom={1}
            fontSize={14}
            color={"#2e473f"}
            variant="h6"
          >
            DETAIL PENERIMAAN
          </Typography>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              TANGGAL PENERIMAAN
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{
                style: { background: "white" },
                readOnly: true
              }}
              type="date"
              required
              size="small"
              error={false}
              name="arrivalDate"
              onChange={handleChange}
              value={formData.arrivalDate}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "200px",
                marginRight: "10px",
              }}
            />
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              inputProps={{readOnly: true}}
              required
              size="small"
              error={false}
              name="isLate"
              onChange={handleChange}
              value={formData.isLate}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "200px",
                background: "white",
                marginRight: "10px",
              }}
            >
              <MenuItem value={false}>Tepat Waktu</MenuItem>
              <MenuItem value={true}>Terlambat</MenuItem>
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              PEMBAYARAN
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              InputProps={{
                inputComponent: NumberFormatting,
                startAdornment: (
                  <InputAdornment position="start">Rp. </InputAdornment>
                ),
              }}
              error={false}
              name="totalPayment"
              onChange={handleChange}
              value={formData.totalPayment}
              variant="outlined"
              fullWidth
              style={{
                maxWidth: "200px",
                background: "white",
                marginRight: "10px",
              }}
            />
            <TextField
              InputLabelProps={{ shrink: true }}
              inputProps={{
                style: { background: "white" },
              }}
              type="date"
              required
              size="small"
              error={false}
              name="paymentDate"
              onChange={handleChange}
              value={formData.paymentDate}
              fullWidth
              variant="outlined"
              style={{
                maxWidth: "200px",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <div className={styles.footerButton}>
            <Button
              variant="contained"
              color="error"
              style={{ marginLeft: "10px" }}
              onClick={() => navigate("/petani/nota-petani")}
            >
              KEMBALI
            </Button>
          </div>
        </form>
      </Card>
    </Grid>
  );
}
